import { render } from "./CreateTag.vue?vue&type=template&id=3f4c62b7&scoped=true"
import script from "./CreateTag.vue?vue&type=script&lang=js"
export * from "./CreateTag.vue?vue&type=script&lang=js"

import "./CreateTag.vue?vue&type=style&index=0&id=3f4c62b7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4c62b7"]])

export default __exports__